import { PowerProfileDataPoint, allDays } from 'greener-ui-library';

export interface PowerProfileJson {
  weekDay: Record<string, number>;
  time: Record<string, string>;
  powerDemandKw: Record<string, number>;
}

/**
 * Convert power profile JSON object from API to PowerProfileDataPoint array
 * API returns data in format:
 * {
 *   week_day: { "0": 0, "1": 0, ... },
 *   time: { "0": "00:00", "1": "00:15", ... },
 *   power_demand_kw: { "0": 12, "1": 12, ... }
 * }
 */
export const convertPowerProfileJsonToDataPoints = (
  powerProfile: PowerProfileJson | null | undefined
): PowerProfileDataPoint[] => {
  if (!powerProfile || !powerProfile.weekDay || !powerProfile.time || !powerProfile.powerDemandKw) {
    return [];
  }

  const dataPoints: PowerProfileDataPoint[] = [];
  const indices = Object.keys(powerProfile.weekDay);

  for (const index of indices) {
    const dayIndex = powerProfile.weekDay[index];
    const time = powerProfile.time[index];
    const power = powerProfile.powerDemandKw[index];

    // Validate data
    if (dayIndex === undefined || !time || power === undefined) {
      continue;
    }

    const day = allDays[dayIndex];
    const [hours] = time.split(':');
    const hour = parseInt(hours);

    // Use custom timestamp format: "dayIndex:HH:MM"
    const timestamp = `${dayIndex}:${time}`;

    dataPoints.push({
      timestamp,
      power,
      day,
      hour,
      dayIndex,
    });
  }

  return dataPoints;
};
